<template>
  <div>
    <div
        v-if="show"
        @mouseover="mouseover"
        @mouseout="mouseout"
        class="box"
        :style="{ top: top + 'px', left: left + 'px' }"
    >
<!--      <span @click="close"><a-icon type="close-circle" /></span>-->
<!--      <div>{{ content }}</div>-->
      <div v-show="show" class="closeBtn el-icon-circle-close " @click="close">
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveWindow',
  props: {
  },
  data() {
    return {
      show: true,
      stepX: 1,
      stepY: 1,
      timer: null,
      maxTop: 0,
      maxLeft: 0,
      top: 0,
      left: 0,
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    // dom 销毁前清除定时器
    clearInterval(this.timer)
  },
  methods: {
    init() {
      this.maxTop = document.documentElement.clientHeight - 150 - 5
      this.maxLeft = document.documentElement.clientWidth - 200 - 5
      this.top = 0
      this.left = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
      this.onresize()
    },

    // 移动函数

    move() {
      if (this.top >= this.maxTop || this.top < 0) {
        this.stepY = -this.stepY
      }
      if (this.left >= this.maxLeft || this.left < 0) {
        this.stepX = -this.stepX
      }
      this.top += this.stepY
      this.left += this.stepX
    },

    mouseover() {
      clearInterval(this.timer)
    },

    mouseout() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.move()
      }, 20)
    },

    close() {
      clearInterval(this.timer)
      this.show = false
    },

    onresize() {
      const that = this
      window.onresize = function () {
        that.init()
      }
    },
  },
}
</script>

<style scoped>
.box {
  background: #eeeeee;
  width: 106px;
  height: 128px;
  border-radius: 5px;
  position: fixed;
  text-align: center;
  padding: 2px;
  color: #ffffff;
  top: 0;
  left: 0;
  z-index: 1000;
}
.box > span {
  text-align: right;
  position: absolute;
  right: 10px;
  top: 10px;
  color: #1b1d20;
  cursor: pointer;
}

.closeBtn {
  display: block;
  position: absolute;
  height: 2px;
  top: 1px;
  font-size: 16px;
  right: 0px;
  line-height: 30px;
  color: black;
}
.closeBtn:hover {
  color: red;
  font-size: 18px;
  font-weight: 700;
}
 img {
  padding-top: 24px;
  width: 100px;
  height: 100px;
}
</style>
